import React from 'react';

export default function UserAvatar({ user, onClick }) {
  if (!user) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      title="Open profile on main website"
      className="p-0 m-0 border-0 bg-transparent cursor-pointer"
    >
      {user.profile_image_url ? (
        <img
          src={user.profile_image_url}
          alt={user.full_name || user.username || 'User'}
          className="h-10 w-10 rounded-full object-cover overflow-hidden cursor-pointer hover:ring-2 hover:ring-violet-400 hover:ring-opacity-50 transition-all duration-200"
        />
      ) : (
        <div className="h-10 w-10 rounded-full bg-gradient-to-r from-violet-600 to-purple-600 text-white flex items-center justify-center font-medium text-lg border-2 border-violet-500 cursor-pointer hover:ring-2 hover:ring-violet-400 hover:ring-opacity-50 transition-all duration-200">
          {(user.full_name || user.username || '?').charAt(0).toUpperCase()}
        </div>
      )}
    </button>
  );
}

